module.exports = __webpack_public_path__ + "static/media/options-outline 3.4397db91.svg";